/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-extra-parens */
import React, { Fragment } from 'react';

export const FeaturedVideosPageMarkupUI = () => {
    return (
        <div className='weather-video-landing'>

            <div className='top-banner-ad'>
                <div className='top-banner-ad-wrapper'>
                </div>
            </div>
            <div className='news-video-sub-nav'>
            </div>
            <section className='featured-videos-section'>
                <div className='featured-videos-section-wrapper'>
                    { /* Desktop Top Section View */ }
                    <div className='desktop-view-top-section-wrapper'>
                        <h1 className='featured-videos-header'>Featured Videos</h1>
                        <div className='main-featured-video'>
                            <div className='main-featured-video-wrapper'></div>
                        </div>
                            
                        <div className='featured-video-banner-ad-300x600'>
                            <div className='featured-video-banner-ad-300x600-wrapper'>
                                <div style={{ width: 300, height: 600 }}></div>
                            </div>
                        </div>
                    </div>
                    { /*Tablet & Mobile View Top Section */ }
                    <div className='tablet-and-mobile-view-top-section-wrapper'>
                        <h1 className='featured-videos-header'>Featured Videos</h1>
                        <div className='main-featured-video'>
                            <div className='main-featured-video-wrapper'></div>
                        </div>
                        <div className='featured-video-ad-small'>
                            <div className='featured-video-ad-small-wrapper'></div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='more-featured-videos-section'>
                <div className='more-featured-videos-section-wrapper'>
                    <div className='more-videos-header'>More Featured Videos</div>
                    <div className='infinite-scroll-videos'>
                        <div className='infinite-scroll-videos-wrapper'>
                            {
                                Array.from(Array(50).keys()).map((index) => {
                                    return (
                                        <Fragment key={`${index}_featured_video`}>
                                            <div className='infinite-scroll-featured-video-item-wrapper'>
                                                <div className='infinite-scroll-featured-video-item'></div>
                                            </div>
                                            {
                                                ((index + 1) % 7 == 0)
                                                    ? <div className='infinite-scroll-featured-video-item-wrapper'>
                                                        <div style={{ width: 300, height: 250 }}></div>
                                                    </div>
                                                    : null
                                            }
                                        </Fragment>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};